import React from 'react';

function BarSearchSvg({ className }) {
  return (
    <svg
      className={className}
      width="576"
      height="84"
      viewBox="0 0 576 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 67">
        <rect
          x="0.580904"
          y="0.580904"
          width="574.838"
          height="82.8382"
          rx="22.6552"
          fill="#F7F6F6"
        />
        <rect
          x="0.580904"
          y="0.580904"
          width="574.838"
          height="82.8382"
          rx="22.6552"
          stroke="#220000"
          strokeWidth="1.16181"
        />
        <path
          id="Vector"
          d="M55.5086 64.5446C69.4823 64.5446 80.8102 53.2167 80.8102 39.243C80.8102 25.2693 69.4823 13.9414 55.5086 13.9414C41.5349 13.9414 30.207 25.2693 30.207 39.243C30.207 53.2167 41.5349 64.5446 55.5086 64.5446Z"
          stroke="#800020"
          strokeWidth="6.3254"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M87.1355 70.871L73.3778 57.1133"
          stroke="#800020"
          strokeWidth="6.3254"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default BarSearchSvg;
